var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58065 0V3.5H0V12.5H2.58065V15H16V0H2.58065ZM2.58065 6H3.94839L4.64516 7L5.34194 6H6.70968L5.34194 8L6.70968 10H5.34194L4.64516 9L3.94839 10H2.58065L3.94839 8L2.58065 6ZM14.9677 14H3.6129V12.5H9.29032V9.5H13.4194V8.5H9.29032V7.5H13.4194V6.5H9.29032V5.5H13.4194V4.5H9.29032V3.5H3.6129V1H14.9677V14Z",
    fill: "#388F4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.dae1276fd383af9fc54d1f5883db0262.svg";
export { ForwardRef as ReactComponent };